export default "__VITE_ASSET__DFowxPn1__"